import uiRouter from '@uirouter/angularjs';
import assign from 'lodash/assign';

import { StorefrontSliderServiceModule } from 'components/storefrontSlider/storefrontSlider.service';
import { StoreInformationServiceModule } from 'services/data/storeInformation.service';
import { LaunchDarklyServiceModule } from 'services/access/launchDarkly/launchDarkly.service';
import { VideoSliderData } from './videoSlider.data';

import template from './videoSlider.html';
import './videoSlider.scss';

const VIDEO_SLIDER_CLASS = 'video-slider-open';
const SLIDER_WIDTH = 350;
const DESKTOP_WIDTH_BREAKPOINT = 992;
const MOBILE_WIDTH_BREAKPOINT = 600;
const NAV_WIDTH_SMALL = 64;
const NAV_WIDTH = 180;
const EMPTY_PAGE_WIDTH_OFFSET = 10;

export const VideoSliderModule = angular
    .module('vln.videoSlider', [
        uiRouter,
        VideoSliderData,
        StorefrontSliderServiceModule,
        StoreInformationServiceModule,
        LaunchDarklyServiceModule
    ])
    .component('videoSlider', {
        template,
        bindings: {},
        controller: class VideoSliderController {
            constructor(
                videoSliderData,
                $rootScope,
                $window,
                storefrontSliderService,
                storeInformationService,
                launchDarklyService,
                $timeout,
                $document,
                $state
            ) {
                'ngInject';

                assign(this, {
                    videoSliderData,
                    $rootScope,
                    $window,
                    $document,
                    $timeout,
                    $state,
                    storefrontSliderService,
                    storeInformationService,
                    launchDarklyService,
                    events: [],
                    isOpen: false,
                    elements: {
                        page: angular.element('.page'),
                        pageHeader: angular.element('.page__header'),
                        slider: angular.element('.vln-videoslider'),
                        body: angular.element('body'),
                        trialStatus: angular.element('.trial-status-bar')
                    }
                });
            }

            $onInit() {
                this.initEvents();
                this.getBaseWidths();

                this.launchDarklyService.isElementStore(this.storeInformationService)
                    .then(isElementStore => this.isElementStore = isElementStore);
            }

            $onDestroy() {
                this.unbindEvents();
            }

            open() {
                if (this.isOpen) return;

                this.isOpen = true;

                if (!this.isElementStore) this.storefrontSliderService.closeSlider();
                angular.element('body').addClass(VIDEO_SLIDER_CLASS);
                this.resizeViews();
                this.$rootScope.$emit('videoSliderModule:sliderOpened');
            }

            close() {
                angular.element('body').removeClass(VIDEO_SLIDER_CLASS);
                this.isOpen = false;
                this.video = undefined;
                this.resizeViews();
                this.$rootScope.$emit('videoSliderModule:sliderClosed');
            }

            initEvents() {
                this.events.push(
                    this.$rootScope.$on('videoSliderService:openSlider', (e, name) => {
                        this.video = this.videoSliderData.videos[name];
                        this.open();
                    }),
                    this.$rootScope.$on('videoSliderService:closeSlider', () => {
                        this.close();
                    }),
                    this.$rootScope.$on('$stateChangeSuccess', this.pageLoadHandler.bind(this))
                );

                angular.element(this.$window).on('resize', this.browserResizeHandler.bind(this));
            }

            unbindEvents() {
                this.events.forEach((handler) => {
                    handler();
                });

                angular.element(this.$window).off('resize', this.browserResizeHandler);
            }

            pageLoadHandler() {
                this.$timeout(() => {
                    this.refreshPageReferences();
                    this.resizeViews();
                }, 0);
            }

            refreshPageReferences() {
                this.elements.page = angular.element('.page');
                this.elements.pageHeader = angular.element('.page__header');
                this.elements.trialStatus = angular.element('.trial-status-bar');
            }

            getBaseWidths() {
                this.setNavWidth();
                this.getBrowserWidth();
                this.adminPageBaseWidth = this.browserWidth - this.navWidth;
                if (this.isEditStorePage(this.$state.current.name)) this.adminPageBaseWidth = this.browserWidth;
            }

            setNavWidth() {
                this.navWidth = angular.element('body').hasClass('nav-menu__small') ? NAV_WIDTH_SMALL : NAV_WIDTH;
            }

            isEditStorePage(page) {
                return page && page.indexOf('editstore') !== -1;
            }

            resizeViews() {
                this.getBaseWidths();

                if (this.isOpen && this.isDesktop) {
                    let pageWidth = this.adminPageBaseWidth;

                    if (this.elements.page.hasClass('page--empty')) {
                        pageWidth -= NAV_WIDTH - EMPTY_PAGE_WIDTH_OFFSET;
                    } else {
                        pageWidth -= SLIDER_WIDTH;
                    }

                    this.elements.pageHeader.css('right', `${SLIDER_WIDTH}px`);
                    this.elements.page.css('width', `${pageWidth}px`);
                    this.elements.trialStatus.css('width', `calc(100% - ${SLIDER_WIDTH}px`);
                } else {
                    this.elements.pageHeader.css('right', '');
                    this.elements.page.css('width', '');
                    this.elements.trialStatus.css('width', '');
                }
            }

            getBrowserWidth() {
                this.browserWidth = $(this.$window).width();
                this.isMobile = this.browserWidth < MOBILE_WIDTH_BREAKPOINT;
                this.isDesktop = this.browserWidth >= DESKTOP_WIDTH_BREAKPOINT;
            }

            browserResizeHandler() {
                if (!this.isOpen) return;

                this.getBaseWidths();

                const transitionProperty = 'transition';
                let oldTransitionDuration = this.elements.page.css(transitionProperty);

                this.elements.page.css(transitionProperty, 'none');
                this.resizeViews();
                this.$timeout(() => {
                    this.elements.page.css(transitionProperty, oldTransitionDuration);
                }, 0);
            }
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/videoSlider/videoSlider.component.js